var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-progress"},_vm._l((_vm.count),function(i){return _c('div',{staticClass:"circle",class:{ done: i < _vm.current, active: i === _vm.current }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }